module.exports = __webpack_public_path__ + "f7c3c0c1bcd227813f7d94c2e405086a.pdf";